import { Card, Grid, Separator } from '@design-systems/canvas-ui'
import Icon, { ShelfIcon } from '@design-systems/react-icons'
import { TRANSLATION_KEYS } from 'locales/translation-keys'
import { useEssentials } from 'hooks/utils/useEssentials'

interface IShortageCard {
    dollars: string | undefined
    percent: string | undefined
}

export const ShortageCard = ({
    dollars = 'n/a',
    percent = 'n/a',
}: IShortageCard) => {
    const { shortage } = TRANSLATION_KEYS
    const { t } = useEssentials()
    return (
        <Card>
            <Grid.Container
                className="hc8-ta-center hc8-pt-3x"
                justify="center"
            >
                <Grid.Item
                    className="hc8-fs-200"
                    size={{
                        xs: 12,
                    }}
                >
                    <Icon svg={ShelfIcon} size="lg" aria-hidden />
                    <span className="hc8-pl-3x">
                        {t(shortage.totalShortage)}
                    </span>
                </Grid.Item>
            </Grid.Container>
            <Grid.Container
                className="hc8-ta-center hc8-pb-8x hc8-pt-4x"
                justify="center"
            >
                <Grid.Item
                    className="hc8-fs-450 hc8-pr-1x"
                    size={{
                        xs: 6,
                    }}
                >
                    {dollars}
                </Grid.Item>
                <Separator direction="vertical"></Separator>
                <Grid.Item
                    className="hc8-fs-450 hc8-pl-1x"
                    size={{
                        xs: 6,
                    }}
                >
                    {percent}
                </Grid.Item>
            </Grid.Container>
        </Card>
    )
}
